// extracted by mini-css-extract-plugin
module.exports =  {"badge":"hMSABL7","variant-white":"KLibqgD","variantWhite":"KLibqgD"};